const Avatar = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-20 h-20',
    xl: 'w-32 h-32'
  };

  const glowSize = {
    sm: '0 0 25px rgba(255, 215, 0, 0.4), 0 0 40px rgba(99, 102, 241, 0.3)',
    md: '0 0 35px rgba(255, 215, 0, 0.5), 0 0 50px rgba(99, 102, 241, 0.4)',
    lg: '0 0 50px rgba(255, 215, 0, 0.6), 0 0 70px rgba(99, 102, 241, 0.5)',
    xl: '0 0 80px rgba(255, 215, 0, 0.7), 0 0 100px rgba(99, 102, 241, 0.6)'
  };

  return (
    <div className="relative flex-shrink-0 group">
      {/* Rayos de sol brillantes */}
      <div className="absolute inset-0 animate-spin" style={{ animationDuration: '20s' }}>
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute top-1/2 left-1/2 w-1 h-full origin-bottom opacity-30 group-hover:opacity-60 transition-opacity duration-500"
            style={{
              background: 'linear-gradient(to top, rgba(255, 215, 0, 0.8), transparent)',
              transform: `translate(-50%, -100%) rotate(${i * 30}deg)`,
              filter: 'blur(1px)'
            }}
          />
        ))}
      </div>

      {/* Avatar principal con imagen */}
      <div
        className={`${sizeClasses[size]} rounded-full relative overflow-hidden transition-transform duration-300 ease-out group-hover:scale-110 cursor-pointer`}
        style={{ boxShadow: glowSize[size] }}
      >
        <img
          src="/damyxia-avatar.jpg"
          alt="DamyxIA"
          className="w-full h-full object-cover"
          draggable="false"
        />
        
        {/* Overlay brillante */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(255,255,255,0.15),transparent_60%)]" />
        
        {/* Pulso animado */}
        <div className="absolute inset-0 animate-pulse" style={{ animationDuration: '3s' }}>
          <div className="w-full h-full bg-gradient-to-br from-yellow-400/10 via-transparent to-violet-500/10" />
        </div>
      </div>
      
      {/* Borde brillante */}
      <div 
        className="absolute inset-0 rounded-full border-2 border-yellow-400/40 group-hover:border-yellow-300/60 transition-all duration-300"
        style={{ boxShadow: 'inset 0 0 15px rgba(255, 215, 0, 0.2)' }}
      />
    </div>
  );
};

export default Avatar;